import { Component, Input, SimpleChanges, Output, EventEmitter, OnChanges } from '@angular/core';

import { TabComponent }     from './tab/tab.component';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less']
})

export class TabsComponent implements OnChanges {
  @Input() tabType: string = 'vertical-list';
  @Input() activeTab: number = 0;
  @Output() selected: EventEmitter<string> = new EventEmitter();
  public tabs: TabComponent[] = [];
  public userClass: string;

  constructor() { }

  ngOnInit(): void {
    this.selectTab(this.tabs[this.activeTab]);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.activeTab) {
      this.selectTab(this.tabs[this.activeTab]);
    }
  }

  public addTab(tab: TabComponent): void {
    if (this.tabs.length === 0) {
      tab.active = true;
    }
    this.tabs.push(tab);
  }

  public selectTab(tab: TabComponent): boolean {
    if (tab) {
      this.tabs.forEach((t) => t.active = false);
      if (tab.tabTitle) {
        this.selected.emit(tab.tabTitle);
      }
      this.activeTab = this.tabs.findIndex((t)=>t==tab);
      tab.active = true;
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tabs/tabs.component.ts